<template>
  <div class="row myrow content-mb-42" v-if="$parent.$parent.rerender">
    <div class="col-xs-12 mycol">
      <div
        v-if="
          $parent.project.SUBCONTRACTORS.filter(s => s.UF_TYPE_RESIDENT === 1)
            .length
        "
      >
        <strong>Российские компании</strong>
      </div>
      <table
        class="co-executor"
        v-if="
          $parent.project.SUBCONTRACTORS.filter(s => s.UF_TYPE_RESIDENT === 1)
            .length
        "
      >
        <thead>
        <tr v-if="$parent.project.UF_IS_LISING == 1">
          <td>ИНН</td>
          <td>Поставщик</td>
          <td>Оборудование</td>
          <td>Стоимость оборудования, тыс. руб.</td>
          <td></td>
        </tr>
        <tr v-else>
          <td>ИНН</td>
          <td>Соисполнитель</td>
          <td>Тип Соисполнителя</td>
          <td>Описание работ по проекту</td>
          <td>Стоимость работ, тыс. руб.</td>
          <td></td>
        </tr>
        </thead>
        <tbody>
        <tr
          v-for="(item, index) in $parent.project.SUBCONTRACTORS"
          v-if="item.UF_TYPE_RESIDENT === 1"
          v-bind:key="index"
        >
          <td
            v-bind:class="{
                'has-error': hasContactError(index, 'UF_OGRN')
              }"
          >
            <input type="hidden" v-model="item.ID" />
            <input type="hidden" v-model="item.UF_COMPANY_ID" />
            {{item.UF_INN}}
<!--            <input
              type="text"
              disabled
              class="i-main-style"
              style="width: 120px;"
              v-model="item.UF_INN"
              v-on:keyup="removeContactError(index, 'UF_OGRN')"
            />-->
            <div class="error-text">
              {{ contactErrorText(index, "UF_OGRN") }}
            </div>
          </td>
          <td
            v-bind:class="{
                'has-error': hasContactError(index, 'UF_NAME')
              }"
          >
            <input type="hidden" v-model="item.ID" />
            <input type="hidden" v-model="item.UF_NAME" />
            {{ item.UF_NAME }}
<!--            <input
              type="text"
              class="i-main-style i-co-executor-style"
              style="width: 300px;"
              v-model="item.UF_NAME"
              disabled
              v-on:keyup="removeContactError(index, 'UF_NAME')"
            />-->
            <div class="error-text">
              {{ contactErrorText(index, "UF_NAME") }}
            </div>
          </td>
          <td
            v-if="$parent.project.UF_IS_LISING != 1"
            v-bind:class="{
                'has-error': hasContactError(index, 'UF_TYPE_COAUTHOR')
              }"
          >
              <textarea
                v-model="item.UF_TYPE_COAUTHOR"
                class="i-main-style t-co-executor-style"
                :disabled="$parent.$parent.projectDisabled"
                v-on:keyup="removeContactError(index, 'UF_TYPE_COAUTHOR')"
                placeholder="Например: научная организация,образовательное учереждение, промышленноое предприятие, проектно-конструкторская организация и т.п."
              ></textarea>
            <div class="error-text">
              {{ contactErrorText(index, "UF_TYPE_COAUTHOR") }}
            </div>
          </td>
          <td
            v-bind:class="{
                'has-error': hasContactError(index, 'UF_SCOPE_OF_WORK')
              }"
          >
              <textarea
                v-model="item.UF_SCOPE_OF_WORK"
                class="i-main-style t-co-executor-style"
                :disabled="$parent.$parent.projectDisabled"
                v-on:keyup="removeContactError(index, 'UF_SCOPE_OF_WORK')"
                :placeholder="
                  $parent.project.UF_IS_LISING != 1
                    ? 'Приведите краткое описание работ, выполняемых соисполнителем в проекте'
                    : ''
                "
              ></textarea>
            <div class="error-text">
              {{ contactErrorText(index, "UF_SCOPE_OF_WORK") }}
            </div>
          </td>
          <td
            v-bind:class="{
                'has-error': hasContactError(index, 'UF_SUMM_WORK')
              }"
          >
            <input
              type="text"
              class="i-main-style i-co-executor-style"
              :disabled="$parent.$parent.projectDisabled"
              @keyup="removeContactError(index, 'UF_SUMM_WORK')"
              v-model="item.UF_SUMM_WORK"
              @keypress="isNumber($event)"
            />
            <div class="error-text">
              {{ contactErrorText(index, "UF_SUMM_WORK") }}
            </div>
          </td>
          <td>
            <a
              v-show="!$parent.$parent.projectDisabled"
              v-on:click="deleteSubContact(index)"
              class="link-delete-row"
            ></a>
          </td>
        </tr>
        </tbody>
      </table>
      <div
        v-if="
          $parent.project.SUBCONTRACTORS.filter(s => s.UF_TYPE_RESIDENT === 2)
            .length
        "
      >
        <strong>Иностранные компании</strong>
      </div>
      <table
        class="co-executor"
        v-if="
          $parent.project.SUBCONTRACTORS.filter(s => s.UF_TYPE_RESIDENT === 2)
            .length
        "
      >
        <thead>
        <tr v-if="$parent.project.UF_IS_LISING == 1">
          <td>Страна</td>
          <td>Идентификационный<br />код компании</td>
          <td>Поставщик</td>
          <td>Оборудование</td>
          <td>Стоимость оборудования, тыс. руб.</td>
          <td></td>
        </tr>
        <tr v-else>
          <td>Страна</td>
          <td>Идентификационный<br />код компании</td>
          <td>Соисполнитель</td>
          <td>Тип Соисполнителя</td>
          <td>Описание работ по проекту</td>
          <td>Стоимость работ, тыс. руб.</td>
          <td></td>
        </tr>
        </thead>
        <tbody>
        <tr
          v-for="(item, index) in $parent.project.SUBCONTRACTORS"
          v-if="item.UF_TYPE_RESIDENT === 2"
          v-bind:key="index"
        >
          <td
            v-bind:class="{
                'has-error': hasContactError(index, 'UF_COUNTRY_ID')
              }"
          >
            <input type="hidden" v-model="item.ID" />
            <input type="hidden" v-model="item.UF_COMPANY_ID" />
            {{ countryName(item) }}
<!--            <input
              type="text"
              disabled
              class="i-main-style"
              style="max-width: 100px;"
              :value="countryName(item)"
              v-on:keyup="removeContactError(index, 'UF_COUNTRY_ID')"
            />-->
            <div class="error-text">
              {{ contactErrorText(index, "UF_COUNTRY_ID") }}
            </div>
          </td>
          <td
            v-bind:class="{
                'has-error': hasContactError(index, 'UF_CODE')
              }"
          >
            <input type="hidden" v-model="item.ID" />
            <input type="hidden" v-model="item.UF_CODE" />
            <span v-html="item.UF_CODE"></span>
<!--            <input
              type="text"
              class="i-main-style i-co-executor-style"
              style="max-width: 150px;"
              disabled
              v-model="item.UF_CODE"
              v-on:keyup="removeContactError(index, 'UF_CODE')"
            />-->
            <div class="error-text">
              {{ contactErrorText(index, "UF_CODE") }}
            </div>
          </td>
          <td
            v-bind:class="{
                'has-error': hasContactError(index, 'UF_NAME')
              }"
          >
            <input type="hidden" v-model="item.ID" />
            <input type="hidden" v-model="item.UF_NAME" />
            {{ item.UF_NAME }}
<!--            <input
              type="text"
              class="i-main-style i-co-executor-style"
              style="max-width: 150px;"
              disabled
              v-model="item.UF_NAME"
              v-on:keyup="removeContactError(index, 'UF_NAME')"
            />-->
            <div class="error-text">
              {{ contactErrorText(index, "UF_NAME") }}
            </div>
          </td>
          <td
            v-if="$parent.project.UF_IS_LISING != 1"
            v-bind:class="{
                'has-error': hasContactError(index, 'UF_TYPE_COAUTHOR')
              }"
          >
              <textarea
                v-model="item.UF_TYPE_COAUTHOR"
                class="i-main-style t-co-executor-style"
                :disabled="$parent.$parent.projectDisabled"
                v-on:keyup="removeContactError(index, 'UF_TYPE_COAUTHOR')"
                placeholder="Например: научная организация,образовательное учереждение, промышленноое предприятие, проектно-конструкторская организация и т.п."
              ></textarea>
            <div class="error-text">
              {{ contactErrorText(index, "UF_TYPE_COAUTHOR") }}
            </div>
          </td>
          <td
            v-bind:class="{
                'has-error': hasContactError(index, 'UF_SCOPE_OF_WORK')
              }"
          >
              <textarea
                v-model="item.UF_SCOPE_OF_WORK"
                class="i-main-style t-co-executor-style"
                style="min-width: 300px;"
                :disabled="$parent.$parent.projectDisabled"
                v-on:keyup="removeContactError(index, 'UF_SCOPE_OF_WORK')"
                :placeholder="
                  $parent.project.UF_IS_LISING != 1
                    ? 'Приведите краткое описание работ, выполняемых соисполнителем в проекте'
                    : ''
                "
              ></textarea>
            <div class="error-text">
              {{ contactErrorText(index, "UF_SCOPE_OF_WORK") }}
            </div>
          </td>
          <td
            v-bind:class="{
                'has-error': hasContactError(index, 'UF_SUMM_WORK')
              }"
          >
            <input
              type="text"
              class="i-main-style i-co-executor-style"
              :disabled="$parent.$parent.projectDisabled"
              @keyup="removeContactError(index, 'UF_SUMM_WORK')"
              v-model="item.UF_SUMM_WORK"
              @keypress="isNumber($event)"
            />
            <div class="error-text">
              {{ contactErrorText(index, "UF_SUMM_WORK") }}
            </div>
          </td>
          <td>
            <a
              v-show="!$parent.$parent.projectDisabled"
              v-on:click="deleteSubContact(index)"
              class="link-delete-row"
            ></a>
          </td>
        </tr>
        </tbody>
      </table>
      <div class="add-row" v-show="!$parent.$parent.projectDisabled">
        <a v-if="$parent.project.UF_IS_LISING == 1" class="link-add-row" @click="showResidentWindow">
          Добавить поставщика
        </a>
        <a v-else @click="showConfirm = true" class="link-add-row"
        >Добавить соисполнителя
        </a>
      </div>
    </div>
    <div
      class="modal fade in"
      v-bind:class="{ show: showConfirm }"
      tabindex="-1"
      role="dialog"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              v-on:click="showConfirm = false"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 class="modal-title">
              Добавление
              {{
                $parent.project.UF_IS_LISING == 1
                  ? "поставщика"
                  : "соисполнителя"
              }}
            </h4>
          </div>
          <div class="modal-body">
            <p v-if="$parent.project.UF_IS_LISING == 1">
              Необходимо указывать ключевого поставщика только в том случае,
              если есть действующий договор с контрагентом. Если заключение
              договора планируется в будущем, пожалуйста, добавьте ключевого
              поставщика позднее.
            </p>
            <p v-else>
              Необходимо указывать ключевого исполнителя только в том случае,
              если есть действующий договор с контрагентом. Если заключение
              договора планируется в будущем, пожалуйста, добавьте ключевого
              исполнителя позднее.
            </p>
            <p></p>
            <p>
              Есть ли действующий договор?
            </p>
          </div>
          <div class="modal-footer">
            <button
              @click="showResidentWindow"
              type="button"
              class="btn btn-primary"
            >
              Да
            </button>
            <button
              type="button"
              class="btn btn-default"
              data-dismiss="modal"
              v-on:click="showConfirm = false"
            >
              Нет
            </button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>

    <div
      class="modal fade in"
      v-bind:class="{ show: showResident }"
      tabindex="-1"
      role="dialog"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              v-on:click="showResident = false"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 class="modal-title">Укажите тип соисполнителя</h4>
          </div>
          <div class="modal-body">
            <select v-model="resident" class="form-control">
              <option :value="1">Российская компания</option>
              <option :value="2">Иностранная компания</option>
            </select>
          </div>
          <div class="modal-footer">
            <button @click="setResident" type="button" class="btn btn-primary">
              Далее
            </button>
            <button
              type="button"
              class="btn btn-default"
              data-dismiss="modal"
              v-on:click="showResident = false"
            >
              Отмена
            </button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>

    <div
      class="modal fade in"
      v-bind:class="{ show: showCompIn }"
      tabindex="-1"
      role="dialog"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              v-on:click="showCompIn = false"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 class="modal-title">Добавление иностранной организации</h4>
          </div>
          <div class="modal-body">
            <div class="form-group">
              <label>Название организации</label>
              <input v-model="inname" class="form-control" />
            </div>
            <div class="form-group">
              <label>Страна</label>
              <select v-model="incountry" class="form-control">
                <option
                  v-for="item in directory.country"
                  :value="item.ID"
                  :key="item.ID"
                  v-text="item.NAME"
                ></option>
              </select>
            </div>
            <div class="form-group">
              <label>Идентификационный код компании</label>
              <input
                v-model="incode"
                v-on:keypress="isNumberAndText($event)"
                class="form-control"
              />
            </div>
          </div>
          <div class="modal-footer">
            <button
              @click="addInSubContact"
              :disabled="inname === '' || incode === '' || incountry === 0"
              type="button"
              class="btn btn-primary"
            >
              Добавить организацию
            </button>
            <button
              type="button"
              class="btn btn-default"
              data-dismiss="modal"
              @click="showCompIn = false"
            >
              Отмена
            </button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>

    <div
      class="modal fade in"
      v-bind:class="{ show: showOgrnFind }"
      tabindex="-1"
      role="dialog"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              v-on:click="showOgrnFind = false"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 class="modal-title">Добавление российской организации</h4>
          </div>
          <div class="modal-body">
            <div class="form-group">
              <label>ОГРН</label>
              <input
                v-model="ogrn"
                class="form-control"
                placeholder="ОГРН организации"
              />
            </div>
            <div class="form-group" v-if="isViewNameOrg">
              <label>Краткое наименование организации</label>
              <input
                v-model="nameOrg"
                class="form-control"
                placeholder="Краткое наименование организации"
              />
            </div>
          </div>
          <div class="modal-footer">
            <button
              @click="addSubContact"
              type="button"
              class="btn btn-primary"
            >
              Добавить организацию
            </button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>

    <!-- Поиск организации без разделения -->
    <div
      class="modal fade in"
      v-bind:class="{ show: showAllSearchOrg }"
      tabindex="-1"
      role="dialog"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              v-on:click="showAllSearchOrg = false"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 class="modal-title">Добавление
              {{
                $parent.project.UF_IS_LISING == 1
                  ? "поставщика"
                  : "соисполнителя"
              }}
            </h4>
          </div>
          <div class="modal-body">

            <p class="select-blue-desc">
              Начните вводить Название или ИНН/Регистрационный номер контрагента,
              затем выберите нужный из списка.
              Если ничего не найдено, добавьте нового контрагента, нажав на '+'
            </p>
            <div class="form-group">
              <div class="form-group add-row autocomplete-form-add">
                <table>
                  <tbody>
                  <tr>
                    <td>
                      <v-autocomplete
                        :items="orgsList"
                        input-class="form-control"
                        :auto-select-one-item="false"
                        :keep-open="false"
                        :component-item="act"
                        v-model="selectedOrg"
                        ref="autoSearchInputRef"
                        :min-len="3"
                        :get-label="getLabel"
                        placeholder="Название или ИНН/Идентификационный код контрагента"
                        @update-items="searchAllOrg"
                        @change="isSearchGood = true"
                        @input="selectSearchItems"
                      ></v-autocomplete>
                    </td>
                    <td class="button-del" v-if="selectedOrg">
                      <a @click="clearAutocomplete" class="link-delete-row"></a>
                    </td>
                    <td class="button-del" v-else-if="!isSearchGood">
                      <a @click="resetAutocomplete" class="link-delete-row"></a>
                    </td>
                    <td class="button-add">
                      <a
                        class="link-add-row"
                        style="width: 20px; padding: 0;"
                        :href='getLinkOlk()'
                        title="Добавить контрагента"
                        target="_blank"></a>
                    </td>
                  </tr>
                  <tr v-if="!isSearchGood">
                    <td colspan="2">
                      <p style="text-align: left; font-style: italic;">По вашему запросу ничего не найдено, попробуйте
                        изменить запрос</p>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>

          </div>
          <div class="modal-footer">
            <button
              @click="addAllTypeSubContact"
              :disabled="!isAddAllOrgGood"
              type="button"
              class="btn btn-primary"
            >
              Добавить организацию
            </button>
            <button
              type="button"
              class="btn btn-default"
              data-dismiss="modal"
              @click="showAllSearchOrg = false"
            >
              Отмена
            </button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>

  </div>
</template>

<script>
import Vue from "vue";
import { ProjectsService } from "@/common/api.service";
import { mapGetters } from "vuex";
import { FETCH_DIRECTORY } from "@/store/actions.type";
import { IS_DEV_MODE } from "@/common/config";
import Item from "@/components/expert/Item.vue";

export default {
  name: "subcontractors",
  data() {
    return {
      showConfirm: false,
      showOgrnFind: false,
      showResident: false,
      showCompIn: false,
      showAllSearchOrg: false,
      resident: 1,
      inname: "",
      incountry: 0,
      incode: "",
      ogrn: "",
      nameOrg: "",
      query: "",
      selectedOrg: "",
      orgsList: [],
      act: Item,
      isViewNameOrg: false,
      isSearchGood: true,
      isAddAllOrgGood: false,
      variantAddOrg: 2//общий вариант добавления организации (1 - раздельно РФ и иностранная компания, 2 - общий диалог)
    };
  },
  methods: {
    hasContactError(col, field) {
      if (typeof this.$parent.$parent.subContractErrors[col] !== "undefined") {
        if (
          typeof this.$parent.$parent.subContractErrors[col][field] !==
          "undefined"
        ) {
          return true;
        }
      }
      return false;
    },
    contactErrorText(col, field) {
      if (typeof this.$parent.$parent.subContractErrors[col] !== "undefined") {
        if (
          typeof this.$parent.$parent.subContractErrors[col][field] !==
          "undefined"
        ) {
          return this.$parent.$parent.subContractErrors[col][field];
        }
      }
      return "";
    },
    removeContactError(col, field) {
      if (typeof this.$parent.$parent.subContractErrors[col] !== "undefined") {
        if (
          typeof this.$parent.$parent.subContractErrors[col][field] !==
          "undefined"
        ) {
          Vue.delete(this.$parent.$parent.subContractErrors[col], field);
        }
      }
      return false;
    },
    countryName(item) {
      if (item.UF_COUNTRY_ID && item.UF_COUNTRY_ID > 0) {
        const result = this.directory.country.filter(
          c => c.ID === item.UF_COUNTRY_ID
        );
        return result.length > 0 ? result[0].NAME : "";
      }else if (item.DATA_OLK && item.DATA_OLK.counterparty && item.DATA_OLK.counterparty.countryCode) {
        return item.DATA_OLK.counterparty.countryCode;
      }
    },
    findСountryByCode(item) {
      if (item && item.counterparty && item.counterparty.countryCode) {
        const result = this.directory.country.filter(
          c => c.CODE === item.counterparty.countryCode
        );
        return result[0];
      }
    },
    addSubContact() {
      ProjectsService.getCoAuthorInfoByOgrn2(this.ogrn, {
        UF_NAME: this.nameOrg
      }).then(({ data }) => {
        if (!data.IS_FIND) {
          this.$toasted.show(data.ERROR, {
            theme: "red",
            position: "top-right",
            duration: 3000
          });
          this.isViewNameOrg = true;
          this.nameOrg = "";
          return;
        }
        this.showOgrnFind = false;
        this.isViewNameOrg = false;
        this.nameOrg = "";
        if (typeof this.$parent.project.SUBCONTRACTORS === "undefined") {
          this.$parent.project.SUBCONTRACTORS = [];
        }
        this.$parent.project.SUBCONTRACTORS.push({
          UF_PROJECT_ID: this.$parent.project.ID,
          UF_TYPE_RESIDENT: this.resident,
          UF_OGRN: data.UF_OGRN,
          UF_NAME: data.UF_NAME,
          UF_COMPANY_ID: data.UF_COMPANY_ID,
          UF_SCOPE_OF_WORK: "",
          UF_SUMM_WORK: "",
          UF_TYPE_COAUTHOR: ""
        });
      }, this);
    },
    addInSubContact() {
      this.showCompIn = false;
      if (typeof this.$parent.project.SUBCONTRACTORS === "undefined") {
        this.$parent.project.SUBCONTRACTORS = [];
      }
      this.$parent.project.SUBCONTRACTORS.push({
        UF_PROJECT_ID: this.$parent.project.ID,
        UF_TYPE_RESIDENT: this.resident,
        UF_NAME: this.inname,
        UF_CODE: this.incode,
        UF_COUNTRY_ID: this.incountry,
        UF_SCOPE_OF_WORK: "",
        UF_SUMM_WORK: "",
        UF_TYPE_COAUTHOR: ""
      });
    },
    addAllTypeSubContact() {
      if (this.isAddAllOrgGood) {
        this.resident = (this.selectedOrg.counterparty.type === "ForeignOrganization") ? 2 : 1;

        if (typeof this.$parent.project.SUBCONTRACTORS === "undefined") {
          this.$parent.project.SUBCONTRACTORS = [];
        }

        if (this.resident === 2) {

          let countryId = 0;
          let country = this.findСountryByCode(this.selectedOrg);
          if (country.ID > 0) {
             countryId = country.ID;
          }

          this.$parent.project.SUBCONTRACTORS.push({
            UF_PROJECT_ID: this.$parent.project.ID,
            UF_TYPE_RESIDENT: this.resident,
            UF_NAME: this.selectedOrg.counterparty.shortName,
            UF_CODE: this.selectedOrg.counterparty.registrationNumber,
            UF_COMPANY_ID: 0,
            UF_COUNTRY_ID: countryId,
            UF_SCOPE_OF_WORK: "",
            UF_SUMM_WORK: "",
            UF_TYPE_COAUTHOR: "",
            DATA_OLK: this.selectedOrg
          });
        } else {
          this.$parent.project.SUBCONTRACTORS.push({
            UF_PROJECT_ID: this.$parent.project.ID,
            UF_TYPE_RESIDENT: this.resident,
            UF_OGRN: (this.selectedOrg.counterparty.ogrnIp)?this.selectedOrg.counterparty.ogrnIp:this.selectedOrg.counterparty.ogrn,
            UF_INN: this.selectedOrg.counterparty.inn,
            UF_NAME: (this.selectedOrg.counterparty.ogrnIp)?this.selectedOrg.counterparty.fullName:this.selectedOrg.counterparty.shortName,
            UF_COMPANY_ID: 0,
            UF_SCOPE_OF_WORK: "",
            UF_SUMM_WORK: "",
            UF_TYPE_COAUTHOR: "",
            DATA_OLK: this.selectedOrg
          });
        }

        console.log(this.$parent.project.SUBCONTRACTORS);

        this.showAllSearchOrg = false;
        this.clearAutocomplete();
        this.resetAutocomplete();
      }
    },
    deleteSubContact(index) {
      this.$parent.project.SUBCONTRACTORS.splice(index, 1);
      if (this.$parent.project.SUBCONTRACTORS.length === 0) {
        //this.project.SUBCONTRACTORS.push({});
      }
    },
    showResidentWindow() {
      this.ogrn = "";
      this.showConfirm = false;
      if (this.variantAddOrg == 1) {
        this.showResident = true;
      } else {
        this.showAllSearchOrg = true;
      }

    },
    setResident() {
      if (this.resident === 1) {
        this.findOrg();
      }
      if (this.resident === 2) {
        this.showIn();
      }
    },
    searchAllOrg(query) {
      this.isSearchGood = true;
      if (query !== undefined) {
        ProjectsService.getFindOrgByGetWay({ search: query }).then(({ data }) => {
          this.orgsList = data.items;
          this.isSearchGood = (this.orgsList.length > 0) ? true : false;
        });
      }
    },
    clearAutocomplete() {
      this.selectedOrg = null
      this.orgsList = [];
      this.isAddAllOrgGood = false;
    },
    resetAutocomplete() {
      this.$refs.autoSearchInputRef.searchText = "";
      this.selectedOrg = null;
      this.isAddAllOrgGood = false;
      this.isSearchGood = true;
    },
    selectSearchItems() {
      if (this.selectedOrg && this.selectedOrg.id !== '') {
        this.isAddAllOrgGood = true;
      }
    },
    getLabel(item) {
      if (item) {
        return item.UF_NUMBER + " " + item.UF_NAME;
      }
    },
    showIn() {
      this.showResident = false;
      this.inname = "";
      this.incode = "";
      this.incountry = 0;
      this.showCompIn = true;
    },
    isNumber: function(evt) {
      evt = evt ? evt : window.event;
      let charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    isNumberAndText: function(evt) {
      var regex = new RegExp("^[a-zA-Zа-яА-Я0-9 ]+$");
      var str = String.fromCharCode(!evt.charCode ? evt.which : evt.charCode);
      if (regex.test(str)) {
        return true;
      }
      evt.preventDefault();
      return false;
    },
    findOrg() {
      this.showResident = false;
      this.ogrn = "";
      this.showOgrnFind = true;
    },
    getLinkOlk() {
      return (this.$parent.project.META.OLK_COUNTERPARTY_PAGE)?this.$parent.project.META.OLK_COUNTERPARTY_PAGE:'https://olk.frprf.ru/counterparty/';
    }

  },
  mounted() {
    this.$store.dispatch(FETCH_DIRECTORY, ["country"]);
  },
  computed: {
    ...mapGetters(["directory"])
  }
};
</script>

<style scoped></style>
